import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation as NavigationSwiper } from 'swiper'
import { useTranslation } from 'react-i18next'
import PhotoWidgetDropzone from './PhotoWidgetDropzone'
import { AddPhoto } from '../../../app/models/Post'
import { CustomFile } from '../../../app/models/file'
import { CustomLabel } from '../Input/CustomLabel'

interface PhotoComponentProps {
  files: any[]
  postImages: AddPhoto[]
  setFiles: (postImages: any[]) => void
  setImage: (image: any[]) => void
  handlePrimary: (e: any, index: any) => void
  handleRemoveImage: (index: any) => void
}

function PhotoComponent({
  files,
  postImages,
  setFiles,
  setImage,
  handlePrimary,
  handleRemoveImage,
}: PhotoComponentProps) {
  const { t } = useTranslation()
  useEffect(() => {
    if (postImages) {
      const initialFiles = postImages.map((image: AddPhoto) => ({
        preview: image.file,
        primary: image.primary,
        id: image.id,
      }))
      setFiles(initialFiles)
      setImage(initialFiles)
    }
  }, [postImages, setFiles, setImage])

  return (
    <div className='mt-4'>
      <CustomLabel show label={t('images') as string}  />
      <PhotoWidgetDropzone
        files={files}
        setFiles={setFiles}
        setImage={setImage}
      />
      {files.length >= 1 && (
        <div
          className={`text-${
            files.length > 15 ? 'danger' : 'black'
          } text-image-size`}
        >
          {t('images_added')}: ({files.length}/15)
        </div>
      )}

      <Swiper
        navigation
        modules={[NavigationSwiper]}
        className="mySwiper"
        slidesPerView={3}
        spaceBetween={7}
        freeMode
      >
        {files.map((file: CustomFile, index: number) => (
          <SwiperSlide
            key={index}
            className="swiper-slide-container white-button"
          >
            <div className="image-container">
              <div className="thumbnail-container">
                {file.primary && (
                  <span className="cover-text">{t('cover_img')}</span>
                )}
                <img
                  src={file.preview || file.path}
                  alt={file.name}
                  className="photo-thumbnail post-upload-image"
                />
                {!file.primary && (
                  <div className="overlay">
                    <button
                      onClick={(e) => handlePrimary(e, index)}
                      className="cover-button"
                    >
                      {t('mark_cover')}
                    </button>
                  </div>
                )}
              </div>
              <i
                onClick={(e) => {
                  e.preventDefault()
                  handleRemoveImage(index)
                }}
                className="fa-solid fa-xmark x-mark-icon uploaded-xmark"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default PhotoComponent
